import {
  get,
  post,
  update,
} from '../helpers'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDatas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        get('/pengguna/list', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchData(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/pengguna/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/pengguna', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateData(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/pengguna', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataKemampuanRoles(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/kemampuan-roles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataKemampuan(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/kemampuan/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDataKemampuan(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/kemampuan', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeDataKemampuan(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/kemampuan', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataRoles(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/roles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataRolesKategoriTiket(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/kategori-tiket/getRoles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataRolesJenisTiket(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/kelolajenistiket/getRoles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDataRoles(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/roles', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDataRolesJenisTiket(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/kelolajenistiket/postRolesJenisTiket', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeDataRoles(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/roles', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeDataRolesJenisTiket(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/kelolajenistiket/deleteRolesJenisTiket', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
